export default function createPhpVersionReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_PHP_VERSION_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_PHP_VERSION_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_PHP_VERSION_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}